<pf-listview
    [title]="'partner.title' | translate"
    [items]="partners"
    [hasSearchSection]="true"
    [searchPlaceholder]="'partner.searchPlaceholder' | translate"
>
    <ng-template #itemTemplate let-partner let-i="index">
        <div class="product-row-layout" (click)="onSelectPartner(partner.id, partner.name)">
            <div class="name-section">
                <div class="product-name">
                    <b class="product-title">{{ partner.name }}</b>
                </div>
            </div>
        </div>
    </ng-template>
</pf-listview>
